import {Button, Heading, Text} from '@primer/react-brand/esm'
import {MarkGithubIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'

import type {Newsletter as NewsletterProps} from '../../marketing-footer.types'

import styles from './Newsletter.module.css'

export function Newsletter(props: NewsletterProps & {className?: string}) {
  const {heading, description, ctaLabel, ctaHref, logoAriaLabel, logoHref, className} = props

  return (
    <section className={clsx(styles.newsletter, className)} aria-labelledby="subscribe-to-newsletter">
      <a href={logoHref} className={styles.logoLink} aria-label={logoAriaLabel}>
        <MarkGithubIcon size={32} className={styles.logo} />
      </a>

      <Heading as="h3" size="6" font="monospace" className={styles.heading} id="subscribe-to-newsletter">
        <span className={styles.headingDot} aria-hidden="true" />
        {heading}
      </Heading>

      <Text as="p" size="200" variant="muted" className={styles.description}>
        {description}
      </Text>

      <Button as="a" href={ctaHref} variant="primary" size="small" className={styles.cta}>
        {ctaLabel}
      </Button>
    </section>
  )
}
